import React from 'react';
import './Page.css';

function RefundPolicy() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Refund Policy</h1>
        <p className="last-updated">Last Updated: December 2024</p>

        <section className="page-section">
          <h2>1. Refund Eligibility</h2>
          <p>
            At ExtraByte, we want you to be satisfied with your learning experience. 
            As an Indian startup, we offer flexible refund options. Refunds are available 
            under the following conditions:
          </p>
          <ul>
            <li>Requests must be made within 7 days of course enrollment</li>
            <li>You must not have accessed more than 20% of the course content</li>
            <li>You must not have submitted any project assignments</li>
            <li>The course must not have been completed</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>2. Non-Refundable Circumstances</h2>
          <p>
            Refunds will not be provided in the following situations:
          </p>
          <ul>
            <li>More than 7 days have passed since enrollment</li>
            <li>You have accessed more than 20% of the course materials</li>
            <li>You have submitted project work or received a certificate</li>
            <li>You have violated our Terms and Conditions</li>
            <li>The course was purchased during a promotional period with special terms</li>
            <li>Course purchased using promotional codes or discount coupons</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>3. How to Request a Refund</h2>
          <p>
            To request a refund:
          </p>
          <ol>
            <li>Contact us through our Contact Us page or email care@extrabyte.in</li>
            <li>Provide your enrollment details and reason for refund</li>
            <li>Include your payment transaction reference (UPI ID, Order ID, etc.)</li>
            <li>Allow 3-5 business days for review</li>
          </ol>
          <p>
            We will review your request and respond within 5 business days (excluding 
            public holidays in India).
          </p>
        </section>

        <section className="page-section">
          <h2>4. Refund Processing</h2>
          <p>
            If your refund request is approved:
          </p>
          <ul>
            <li>The refund will be processed within 7-10 business days</li>
            <li>For UPI payments: Refund will be credited to the same UPI ID</li>
            <li>For Card payments: Refund will be credited to the same card</li>
            <li>For Net Banking: Refund will be credited to the source account</li>
            <li>You will receive a confirmation email and SMS once processed</li>
            <li>Access to course materials will be revoked immediately</li>
          </ul>
          <p className="info-note">
            Note: Refund processing time may vary depending on your bank or payment provider. 
            Please allow 5-7 additional business days for the amount to reflect in your account.
          </p>
        </section>

        <section className="page-section">
          <h2>5. Partial Refunds</h2>
          <p>
            Partial refunds may be considered on a case-by-case basis for:
          </p>
          <ul>
            <li>Technical issues that prevented course access (if not resolved within 48 hours)</li>
            <li>Significant content discrepancies from the course description</li>
            <li>Medical emergencies or extenuating circumstances (subject to documentation)</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>6. Course Cancellation by ExtraByte</h2>
          <p>
            If we cancel a course before you complete it:
          </p>
          <ul>
            <li>You will receive a full refund including any processing fees</li>
            <li>Or the option to transfer to an equivalent course at no extra cost</li>
            <li>Refunds will be processed within 7 business days</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>7. Payment Processing Fees</h2>
          <p>
            Payment gateway charges (typically 2-3% for UPI/Cards) are absorbed by ExtraByte. 
            You will receive a full refund of the amount you paid, without any deductions for 
            processing fees, as part of our commitment to Indian learners.
          </p>
        </section>

        <section className="page-section">
          <h2>8. Bundle and Promotional Offers</h2>
          <p>
            Courses purchased as part of a bundle or during promotional offers may have 
            different refund terms. These will be clearly stated at the time of purchase. 
            Festive season offers and special Indian holiday discounts may have modified 
            refund policies.
          </p>
        </section>

        <section className="page-section">
          <h2>9. Chargebacks and Disputes</h2>
          <p>
            If you initiate a chargeback with your payment provider without first 
            contacting us, we reserve the right to dispute the chargeback and provide 
            evidence of service delivery. Please contact us first to resolve any issues - 
            we are committed to finding a fair solution for all Indian learners.
          </p>
        </section>

        <section className="page-section">
          <h2>10. Questions and Support</h2>
          <p>
            If you have any questions about our Refund Policy, please contact us:
          </p>
          <ul>
            <li>Email: care@extrabyte.in</li>
            <li>Phone: +91 98765 43210 (Mon-Sat, 9 AM - 7 PM IST)</li>
            <li>Contact Form: Available on our Contact Us page</li>
          </ul>
          <p>
            We are committed to resolving any concerns you may have and supporting your 
            learning journey.
          </p>
        </section>
      </div>
    </div>
  );
}

export default RefundPolicy;
